import React from 'react';

import { LoadingUnit } from '@/components/Loading';
import { useScreenMatch } from '@/hooks/useScreenMatch';

import { Root } from './FailedBanner.styles';

export const FailedBannerPreloader = () => {
  const { isMobile } = useScreenMatch();

  return (
    <Root vertical gap={2} mobileGap={2} isMobile={isMobile} isLoading>
      <LoadingUnit height={6} width={36} />
      <LoadingUnit height={12} width={isMobile ? 70 : 100} />
    </Root>
  );
};
